module.exports = __webpack_public_path__ + "static/media/map_bg.a9e817ae.png";